import Ajax from 'js/utils/ajax/ajax.js';

export const editConcern = (concern) =>
  Ajax.patch(`/shops/v1/concerns/${concern.concernId}`, concern);
